import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { IQuerySearch } from '@shared/data-access/interfaces';
import { PersonalParticularModel, PersonalVerifyModel } from '@shared/data-access/models';

// items
export const loadItems = createAction('[PersonalVerificationInfo] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[PersonalVerificationInfo] Load items success', props<{ data: PaginationAdapter<PersonalParticularModel> }>());

// item
export const loadItem = createAction('[PersonalVerificationInfo] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[PersonalVerificationInfo] Load item success', props<{ items: PersonalVerifyModel[] }>());

// list
export const updateList = createAction('[PersonalVerificationInfo] Update list', props<{ list: PersonalParticularModel[] }>());
